<template>
  <tsoft-wrapper fill :loading="loading.ticket">
    <div class="ticket-list">
      <h2>Ваши тикеты</h2>
      <template v-if="isTicketsEmpty && !loading.ticket">
        <div class="ticket-list__empty">Тикеты отсутствуют</div>
      </template>
      <template v-else>
        <div class="ticket-list__links">
          <div
            class="ticket-list__link"
            v-for="(ticket, idx) in ticketsForList"
            :key="idx"
          >
            <div
              class="ticket-list__link-item cursor-pointer"
              @click="fetchTicket(ticket.ID)"
            >
              <div class="ticket-list__id">№ {{ ticket.ID }}</div>
              <div class="ticket-list__title">{{ ticket.TITLE }}</div>
              <b-icon-circle-fill
                :variant="variantBadge(ticket.STATUS_ID)"
                class="ticket-list__icon"
              >
              </b-icon-circle-fill>
            </div>
          </div>
        </div>
        <div class="d-flex mt-auto mx-auto">
          <b-pagination
            v-show="rowsTickets > 15"
            v-model="currentPage"
            :total-rows="rowsTickets"
            :per-page="perPage"
            class="mb-0"
          ></b-pagination>
        </div>
      </template>
    </div>
  </tsoft-wrapper>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      currentPage: 1,
      perPage: 15,
    };
  },

  filters: {
    pathTicket(id) {
      return `/tickets/${id}`;
    },
  },

  computed: {
    ...mapGetters("tickets", ["loading", "tickets"]),
    ...mapGetters("auth", ["currentUser"]),

    rowsTickets() {
      return this.tickets.length;
    },

    ticketsForList() {
      return this.tickets.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },

    isTicketsEmpty() {
      return _.isEmpty(this.tickets);
    },

    isAdmin() {
      return this.currentUser.role.includes("administrator");
    },
  },

  methods: {
    ...mapMutations("tickets", ["RESET_TICKETS"]),
    ...mapActions("tickets", ["fetchTickets", "getAllTickets", "fetchTicket"]),

    variantBadge(statusId) {
      switch (statusId) {
        case 1:
          return "info";
        case 2:
          return "warning";
        case 3:
          return "danger";
        case 4:
          return "success";
        default:
          return "info";
      }
    },
  },

  mounted() {
    this.isAdmin ? this.getAllTickets() : this.fetchTickets(this.currentUser.id);
  },

  destroyed() {
    this.RESET_TICKETS()
  }
};
</script>
